import { useEffect, useRef } from "react";
import {
  NotificationRealtimeEnvelope,
  notificationSocketService,
} from "services/notificationSocket.service";
import { getAccessToken } from "services/token.service";

export const useNotificationSocket = (
  onNotification: (payload: NotificationRealtimeEnvelope) => void,
  enabled = true,
): void => {
  const accessToken = getAccessToken() || "";
  const onNotificationRef = useRef(onNotification);

  useEffect(() => {
    onNotificationRef.current = onNotification;
  }, [onNotification]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const socket = notificationSocketService.connect(accessToken);

    if (!socket) {
      return;
    }

    const handleNotification = (
      payload: NotificationRealtimeEnvelope,
    ): void => {
      onNotificationRef.current(payload);
    };

    notificationSocketService.onNotification(handleNotification);

    return () => {
      notificationSocketService.offNotification(handleNotification);
    };
  }, [accessToken, enabled]);
};
